<section class="flex h-full flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
  @if (hasMeal) {
    <div class="flex flex-row items-center justify-between">
      <div class="flex items-center gap-2">
        <h3 class="text-primary-900">
          {{ "calculator.meal" | transloco }}
        </h3>
      </div>
      <p-button
        [label]="'calculator.addMeal' | transloco"
        variant="outlined"
        (onClick)="addMeal()"
        icon="pi pi-plus"
      />
    </div>

    @for (meal of meals; track $index) {
      <article class="flex flex-row gap-3 rounded-lg bg-white p-4">
        <div
          class="rounded-lg bg-primary-50 p-3 text-heading-4 text-primary-950"
        >
          {{ meal.mealPercentage | decimalToPercent }}
        </div>
        <div class="flex flex-1 flex-col gap-1">
          <div class="flex flex-1 flex-row items-center justify-between">
            <div class="flex flex-row items-center gap-3">
              @if (meal.type) {
                <div class="paragraph-med text-primary-950">
                  {{ "categoryType." + meal.type | transloco }}
                </div>
              }
              <app-item-validation-badge
                class="ml-2"
                scope="meal"
                [index]="$index"
                (badgeClick)="onItemValidationBadgeClick($event)" />
            </div>
          </div>
          <div class="text-paragraph-xs-reg text-greyscale-700">
            <span class="ml-1">{{
              meal.localSeasonalPercent | decimalToPercent
            }}</span>
            <span>
              {{ "prestation.localAndSeasonalDashboard" | transloco }}</span
            >
          </div>
        </div>
        <div class="justify-end">
          <p-button
            icon="pi pi-ellipsis-v"
            (click)="op.toggle($event)"
            rounded
            variant="text"
            size="small"
          ></p-button>
          <p-popover #op>
            <div class="flex flex-col">
              <p-button
                icon="pi pi-pencil"
                [label]="'edit' | transloco"
                variant="text"
                (onClick)="editMeal($index)"
              />
              <p-button
                icon="pi pi-trash"
                [label]="'delete' | transloco"
                variant="text"
                severity="danger"
                (onClick)="confirmDelete($index)"
              />
            </div>
          </p-popover>
        </div>
      </article>
    }
  } @else {
    <app-prestation-empty-state
      [title]="'calculator.emptyState.meal.title' | transloco"
      [text]="'calculator.emptyState.meal.text' | transloco"
      [buttonLabel]="'calculator.addMeal' | transloco"
      [action]="addMeal"
    />
  }
</section>
<p-confirm-dialog></p-confirm-dialog>
